import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const TextContainer = styled.div`
  margin-top: 25px;
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 1.2rem;
  }
`;
